import {
  ExecEdPromoHighlightProps,
  UseExecPromoHighlight,
  ExecEdPromoHighlightVariants,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "eePromoHighlightOrBanner";

const useExecPromoHighlight: UseExecPromoHighlight = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdPromoHighlightProps;
    variantCustomId: ExecEdPromoHighlightVariants;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        backgroundColor: "default",
        promoBanner: undefined,
        certificateFactoid: {
          showFactoidDesktop: false,
          showFactoidMobile: false,
          variantColor: "default",
          factoidText: "",
          factoidHeader: "",
          factoidIcon: "",
          position: 0,
        },
      },
    };
  }

  return {
    isLoading,
    variant: value?.variantCustomId,
    data: {
      backgroundColor: value?.data?.backgroundColor || "default",
      promoBanner: value?.data?.promoBanner || undefined,
      certificateFactoid: value?.data?.certificateFactoid || undefined,
    },
  };
};

export default useExecPromoHighlight;
